"use client";

import React from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "01",
  title: "Negoziazione",
  description: "Definizione strategica degli obiettivi e gestione delle trattative preliminari per massimizzare il valore dell'accordo e allineare le aspettative delle parti."
}, {
  number: "02",
  title: "Redazione",
  description: "Elaborazione meticolosa di contratti e clausole su misura, garantendo chiarezza espositiva e la massima sicurezza giuridica per il cliente."
}, {
  number: "03",
  title: "Revisione",
  description: "Analisi critica e ottimizzazione dei testi contrattuali esistenti per identificare criticità, mitigare i rischi e prevenire futuri contenziosi."
}, {
  number: "04",
  title: "Esecuzione",
  description: "Assistenza continuativa nella fase attuativa per assicurare il corretto adempimento degli obblighi e la gestione di eventuali variazioni in corso d'opera."
}];
export default function IlCicloDellaConsulenza() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}